import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import Button from './Button.js';
import Plus from './Icons/Plus.js';
const ButtonIcon = (props) => {
    return (React.createElement(ButtonIconStyled, { size: "mini", className: "button-icon", onClick: props.onClick },
        React.createElement("div", null,
            React.createElement(IconStyled, { size: "15px", color: THEME.COLOR_SECONDARY }),
            React.createElement(ValueDivStyled, null, props.value))));
};
export default ButtonIcon;
const ButtonIconStyled = styled(Button) `
  &.button-icon {
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    background-color: ${THEME.COLOR_SECONDARY};
    border-radius: 15px;
    box-shadow: none;
    text-transform: none;
    font-weight: normal;
    font-size: 0.6em;
    border: 0.01em solid ${THEME.ACCENT_BORDER};
    height: 30px;
    padding: 8px 9px 8px 7px;
    margin-right: 10px;
  }

  &.button-icon:hover {
    background-color: ${THEME.ACCENT_SURFACE_STRONG};
    border: 0.01em solid ${'transparent'};
  }

  &.button-icon:focus:after {
    display: none;
  }
`;
const IconStyled = styled(Plus) `
  background-color: ${THEME.COLOR_ACCENT};
  border-radius: 100%;
  vertical-align: middle;
  padding: 1px;
`;
const ValueDivStyled = styled.div `
  display: inline-block;
  vertical-align: middle;
  margin-left: 5px;
  color: ${THEME.COLOR_PRIMARY};
`;
//# sourceMappingURL=ButtonIcon.js.map